import axios from "axios";

export enum SiteType {
    PROPERTY_OWNER = "PROPERTY_OWNER",
    PROPERTY_MANAGER = "PROPERTY_MANAGER",
    SERVICE_PROVIDER = "SERVICE_PROVIDER",
}

export interface Site {
    id: string;
    name: string;
    companyName: string;
    context: Record<string, string>;
    active: boolean;
    idCode: string;
    type: SiteType;
}

export interface CreateSiteCommand {
    name: string;
    companyName: string;
    context: Record<string, string>;
    type: SiteType;
}

export interface ChatMessageHint {
    label: string;
    message: string;
}

export interface FeedbackPageSettings {
    messageHints?: ChatMessageHint[];
}

export interface PublicSiteInfo {
    name: string;
    feedbackPageSettings?: FeedbackPageSettings;
}

export const createSite = async (command: CreateSiteCommand): Promise<Site> => {
    const res = await axios.post("/api/site", command);
    return res.data;
}

export const getSite = async (siteId: string): Promise<Site> => {
    const res = await axios.get(`/api/site/${siteId}`);
    return res.data;
}

export const getSitePublicInfo = async (idCode: string): Promise<PublicSiteInfo | null> => {
    try {
        const res = await axios.get(`/api/public/site/${idCode}`);
        return res.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
            return null;
        }
        throw error;
    }
}